// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"e0b93c4e","836":"23b70430","862":"6239b8bd"}[chunkId] + ".chunk.css";
};